import React, { useState, useEffect, useCallback, memo } from 'react';
import { Link, useParams } from 'react-router-dom';
import { verifyEmail } from '../../api/auth';

import styles from './styles/Auth.module.css';

const VerifyEmail = () => {
    const [status, setStatus] = useState('verifying');
    const [error, setError] = useState('');
    const { token } = useParams();
    const [isSendVerification, setIsSendVerification] = useState(false);

    const handleVerification = useCallback(async () => {
        try {
            await verifyEmail(token);
            setStatus('success');
            setIsSendVerification(true);
        } catch (error) {
            setStatus('error');
            setError(error.message);
        }
    }, [token]);

    useEffect(() => {
        if (!isSendVerification) {
            handleVerification();
        }
    }, [handleVerification, isSendVerification]);

    return (
        <div className={styles.container}>
            <Link to="/">
                <img 
                    src="/icons/android-icon-192x192.png" 
                    alt="JetChats Logo" 
                    className={styles.logo}
                />
            </Link>
            <div className={styles.card}>
                {status === 'verifying' && (
                    <>
                        <h2>Verifying your email</h2>
                        <p className={styles.text}>Please wait while we verify your email address...</p>
                    </>
                )}

                {status === 'success' && (
                    <>
                        <h2>Email verified!</h2>
                        <p className={styles.text}>Your email has been successfully verified. You can now login to your account.</p>
                        <Link to="/login" className={styles.submitButton} style={{ marginTop: '1rem' }}>
                            Login
                        </Link>
                    </>
                )}

                {status === 'error' && (
                    <>
                        <h2>Verification failed</h2>
                        <p className={styles.error}>{error}</p>
                        <Link to="/register" className={styles.submitButton} style={{ marginTop: '1rem' }}>
                            Sign up
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
};

export default memo(VerifyEmail);
